module.exports = __webpack_public_path__ + "media/images/icon_arrow-936fc9b12d7af344541ae305f0e7d68f.svg";